module.exports = __webpack_public_path__ + "img/rs_sodhi.de7c87c5.jpg";